import { useState, type ComponentPropsWithRef } from "react";
import { useTranslation } from "react-i18next";
import { useOttUser } from "hooks/use-ott-user";
import {
  CostDisclaimerText,
  CostEstimationText,
  Container,
  CostDisclaimerTitle,
  EstimatedCost,
  ErrorMessage,
} from "./styles";
import { TripCostInput } from "../trip-cost-input";

export function TripCostEstimation(props: ComponentPropsWithRef<"div">) {
  const ottUser = useOttUser("glinda");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { t } = useTranslation("screens", { keyPrefix: "offer.tripCost" });

  return (
    <Container {...props}>
      <CostEstimationText>
        <CostDisclaimerTitle>{t("tripCostTitle")}</CostDisclaimerTitle>
        <CostDisclaimerText>
          {t("subtitle", { context: ottUser && "advisor" })}
        </CostDisclaimerText>
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </CostEstimationText>
      <EstimatedCost>
        <TripCostInput
          onError={(error) => {
            setErrorMessage(error);
          }}
        />
      </EstimatedCost>
    </Container>
  );
}
